import React from 'react';
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {bookmarkList, bookmarkListAddServ} from "../../store/modules/bookmarkList";
import {ga4SendOnce} from "../../function";
import {GA4_CUSTOM_CLAN_DETAIL_CLICKED} from "./const/ga4";

const NoBorderButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  border-radius: 6px;
  padding: 0 2px;
  font-size: 12px;
  transition: all 0.2s linear;

  &::before {
    content: '';
    display: inline-block;
    width: 24px;
    height: 24px;
  }

  &.off {

    &:hover {
      opacity: 1;
    }

    &::before {
      background: ${props => `url('${props.theme.icon.path}/connect/btn_bookmark.svg')`} no-repeat center;
      background-size: 24px 24px;
    }
  }

  &.on {
    opacity: 1;

    &::before {
      background: ${props => `url('${props.theme.icon.path}/connect/btn_bookmark_on.svg')`} no-repeat center;
      background-size: 24px 24px;
    }
  }
`;

const Button = styled(NoBorderButton)`
  border: 1px solid ${props => props.theme.color.dark_300};
`;
const CustomClanFavoriteButton = ({data, noBorder}) => {
    const bookmarks = useSelector((state) => {
        let arr = state?.bookmarkList.bookmarks.filter((item) => item?.server_id === data.server_id);
        return arr.length > 0
    });
    const dispatch = useDispatch();

    const onClickButton = (e) => {
        e.stopPropagation();
        ga4SendOnce(GA4_CUSTOM_CLAN_DETAIL_CLICKED)
        if (bookmarks) {
            dispatch(bookmarkList(data, 'remove'))
        } else {
            dispatch(bookmarkListAddServ({...data}))
        }
    }

    if (noBorder) {
        return <NoBorderButton onClick={onClickButton} className={`${bookmarks ? 'on' : 'off'}`}/>
    }

    return (
        <Button onClick={onClickButton} className={`${bookmarks ? 'on' : 'off'}`}/>
    );
};

export default CustomClanFavoriteButton;